var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChartGenerator',{attrs:{"chart-options":_vm.ruleChartOptions,"chart-data":_vm.ruleChartData,"chart-id":_vm.chartId,"plugins":_vm.plugins,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }